import { Component, OnInit, inject } from '@angular/core';
import {AttributionService} from "../services/attribution/attribution.service";
import {AttributionResult} from "../services/attribution/attribution-result.model";
import {Subject} from "rxjs";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: 'app-attribution',
    templateUrl: './attribution.component.html',
    styleUrls: ['./attribution.component.scss'],
    standalone: false
})
export class AttributionComponent implements OnInit {
    private readonly attributionService = inject(AttributionService);


    public cancel$: Subject<void>;
    public confirm$: Subject<void>;

    public attribution: AttributionResult;

    constructor() {
        this.cancel$ = new Subject();
        this.confirm$ = new Subject();
    }

    ngOnInit(): void {
        this.attributionService.retrieveAttribution()
            .pipe(untilDestroyed(this))
            .subscribe(
                result => this.attribution = result,
                () => this.dismissModal());
    }

    public dismissModal(): void {
        this.cancel$.next();
    }
}
